<div class="aideConfig">
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Fichier de configuration PackGémini</h2>
    </div>
    <div class="inputWithButton">
      <app-file-input [(content)]="conf"></app-file-input>
      <button mat-mini-fab color="primary" (click)="downloadFile('PackgeminiV2_CDS')">
        <mat-icon>save_alt</mat-icon>
      </button>
      <button mat-mini-fab color="primary" (click)="importFile('conf')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="file">
    <div class="title">
      <h2>Guide: <span class="GTitle">Présentation de PackGémini</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="userGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('userGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Domaines applicatifs</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="dsiGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('dsiGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2>Guide: <span class="GTitle">Données collectées</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="dataGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('dataGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Suivi de commande</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="commandGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('commandGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Suivi d'application</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="appsGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('appsGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Suivi des alertes</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="alertGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('alertGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Facturation</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="facturationGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('facturationGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Facturation administrateur</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="facturationGuideAdmin"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('facturationGuideAdmin')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>
  <div class="file">
    <div class="title">
      <h2 class="guide-title">Guide: <span class="GTitle">Administration</span></h2>
    </div>
    <div class="inputWithButton">
      <app-file-input class="input-space" [(content)]="adminGuide"></app-file-input>
      <button mat-mini-fab color="primary" (click)="importFile('adminGuide')">
        <mat-icon>cloud_upload</mat-icon>
      </button>
    </div>
  </div>

  <mat-divider></mat-divider>
  
  <div class="file">
    <!-- Password management -->
    <div class="title">
      <h2 class="guide-title" style="text-align: center;" >Gestion des mots de passe <br> Recette / Integration </h2>
    </div>
    <div class="password-buttons">
      <button mat-raised-button color="primary" (click)="openChangePasswordDialog()">
        <mat-icon>lock</mat-icon>
        Modifier mon mot de passe 
      </button>
      <button mat-raised-button color="accent" (click)="openSetPasswordDialog()">
        <mat-icon>person_add</mat-icon>
        Définir mot de passe pour un utilisateur
      </button>
    </div>
  </div>

  <mat-divider></mat-divider>
  
  <div class="file">
    <!-- enable debug pack -->
    <mat-slide-toggle [checked]="debugMode" (change)="setDebugMode($event.checked)">
      <b>Mode débogage 🛠️</b>
    </mat-slide-toggle>

  </div>

  <div class="file">
    <!-- enable debug pack -->
    <mat-slide-toggle [checked]="centreCompetenceMode" (change)="setCentreCompetenceMode($event.checked)">
      <b>Mode Gestion de la demande </b>
    </mat-slide-toggle>

</div>

<!-- Change Own Password Dialog -->
<div *ngIf="showChangePasswordDialog" class="password-dialog-overlay" (click)="closeChangePasswordDialog()">
  <div class="password-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Modifier votre mot de passe</h2>
      <button mat-icon-button (click)="closeChangePasswordDialog()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-content">
      <!-- Old password field -->
      <mat-form-field class="full-width">
        <mat-label>Ancien mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="oldPassword" placeholder="Entrez votre ancien mot de passe">
      </mat-form-field>

      <!-- New password field -->
      <mat-form-field class="full-width">
        <mat-label>Nouveau mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="newPassword" placeholder="Minimum 8 caractères">
        <mat-hint>Minimum 8 caractères</mat-hint>
      </mat-form-field>

      <!-- Confirm password field -->
      <mat-form-field class="full-width">
        <mat-label>Confirmer le mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="confirmPassword" placeholder="Confirmez votre mot de passe">
        <mat-error *ngIf="newPassword && confirmPassword && newPassword !== confirmPassword">
          Les mots de passe ne correspondent pas
        </mat-error>
      </mat-form-field>
    </div>

    <div class="dialog-footer">
      <button mat-button (click)="closeChangePasswordDialog()" [disabled]="isChangingPassword">
        Annuler
      </button>
      <button mat-raised-button color="primary" (click)="changeOwnPassword()" [disabled]="isChangingPassword || !oldPassword || !newPassword || !confirmPassword">
        {{ isChangingPassword ? 'Traitement...' : 'Valider' }}
      </button>
    </div>
  </div>
</div>

<!-- Set Password For Another User Dialog -->
<div *ngIf="showSetPasswordDialog" class="password-dialog-overlay" (click)="closeSetPasswordDialog()">
  <div class="password-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Définir le mot de passe initial d'un utilisateur</h2>
      <button mat-icon-button (click)="closeSetPasswordDialog()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-content">
      <!-- Target user identifier -->
      <mat-form-field class="full-width">
        <mat-label>Identifiant de l'utilisateur</mat-label>
        <input matInput [(ngModel)]="targetUserIdentifier" placeholder="Ex: ABC12345">
        <mat-hint>Entrez l'identifiant de l'utilisateur pour lequel définir un mot de passe</mat-hint>
      </mat-form-field>

      <!-- Password field -->
      <mat-form-field class="full-width">
        <mat-label>Mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="adminPassword" placeholder="Minimum 8 caractères">
        <mat-hint>Minimum 8 caractères</mat-hint>
      </mat-form-field>

      <!-- Confirm password field -->
      <mat-form-field class="full-width">
        <mat-label>Confirmer le mot de passe</mat-label>
        <input matInput type="password" [(ngModel)]="adminConfirmPassword" placeholder="Confirmez le mot de passe">
        <mat-error *ngIf="adminPassword && adminConfirmPassword && adminPassword !== adminConfirmPassword">
          Les mots de passe ne correspondent pas
        </mat-error>
      </mat-form-field>
    </div>

    <div class="dialog-footer">
      <button mat-button (click)="closeSetPasswordDialog()" [disabled]="isSettingPassword">
        Annuler
      </button>
      <button mat-raised-button color="primary" (click)="setPasswordForUser()" [disabled]="isSettingPassword || !targetUserIdentifier || !adminPassword || !adminConfirmPassword">
        {{ isSettingPassword ? 'Traitement...' : 'Valider' }}
      </button>
    </div>
  </div>
</div>